<div *ngIf="!listDisplay">
  <div *ngIf="!display">
    <div class="content-wrapper">
      <div>
        <div>
          <div>
            <div>
              <div>
                <div class="btn-wrapper">
                  <button mat-flat-button class="btn-back btn-warn" color="" aria-label="Back" (click)='back()'>
                    <span>{{'questions.typeOfQuestions.TrueOrFalse.btnBack' | translate}}</span>
                  </button>
                  <span class="spacer"></span>
                  <!-- <button mat-flat-button color="" class="btn-warn" aria-label="Preview" disabled="disabled">
                    <span>Preview</span>
                  </button> -->
                  <button [disabled]="saveDisable || addQuestionForm.invalid" mat-flat-button color="" class="btn-primary" aria-label="Save" (click)='saveQuestion()'>
                    <span>{{'questions.typeOfQuestions.TrueOrFalse.btnSave' | translate}}</span>
                  </button>
                </div>
              </div>
              <div class="text-msg" *ngIf="saveDataValidation==true">
                <div class="col-md-12">
                  <span>{{'questions.typeOfQuestions.TrueOrFalse.formIncomplete' | translate}}</span>
                </div>
              </div>
              <div class=" header-row">
                <div>
                  <div class="body-section title">
                    <mat-icon>library_add</mat-icon> &nbsp;
                    <span>{{'questions.typeOfQuestions.TrueOrFalse.title' | translate}}</span>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <form [formGroup]="addQuestionForm">
                    <div class="body-section-2">
                      <label class="que-label">{{'questions.typeOfQuestions.TrueOrFalse.labelQuest' | translate}}</label>
                      <ckeditor #myEditor formControlName="question" [editor]="Editor" (ready)="onReady($event)" (click)="onClick(true)"></ckeditor>
                      <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                      <!-- <ckeditor formControlName="question" data="Enter here..." [config]="ckeditorConfig" [ngClass]="{'ckeditor-loading': isCkeditorLoading}" (ready)="onCkeditorReady()"></ckeditor> -->
                    </div>
                  </form>
                </div>
              </div>
              <div>
                <div>
                  <div class="add-option-main">
                    <div *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                      <label class="Questions-score">{{'questions.typeOfQuestions.TrueOrFalse.labelQuestScore' | translate}}</label>
                      <input min="0" value="newEvent" [(ngModel)]="newEvent" class="form-control scoreInput" readonly
                        (keypress)="keyPressNumbers($event)">
                    </div>
                    <div class="score-wrapper ">
                      <label class="mrg-top" *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.TrueOrFalse.labelSetScore' | translate}}</label>
                      <label class="mrg-top" *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">{{'questions.typeOfQuestions.standard.labelStyle' | translate}}</label>
                      <div class="add-option" *ngFor="let o of addedOptions; let i = index">
                        <div class="input-class-container"  *ngIf="scoringTypeId != ScoringTypeEnum.On180360Degree">
                          <mat-radio-button class="radio-btn-class" type="radio" value="{{o?.answerDescription?.description}}"
                            (change)="onCheckRadioOption(o,$event.value)" [checked]="o?.answerValid==true" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                          </mat-radio-button>
                          <input type="number" class="form-control" min="0" max="9999.99" step=".01" value="" [(ngModel)]="o.correctPoints"
                          (change)="addScore(o)" (input)="validateInput($event, o, 'options')" (keypress)="omit_special_char($event)">
                          <app-preview-option-editor [optionValue]="o?.answerDescription?.description"> </app-preview-option-editor>
                        </div>

                        <div class="input-class-container"  *ngIf="scoringTypeId == ScoringTypeEnum.On180360Degree">
                          <div class="row">
                            <div class="col-md-6">
                              <app-preview-option-editor [optionValue]="o?.answerDescription?.description"> </app-preview-option-editor>
                            </div>
                            <div class="col-md-6" style="width: 20%;">
                              <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid" ng-reflect-model=""
                                (change)="onSelectStyle($event, o?.answerDescription?.description)" [(ngModel)]="o.styleid">
                                <option [value]="0">
                                  {{'questions.typeOfQuestions.TrueOrFalse.optionSelect' | translate}}
                                </option>
                                <option *ngFor="let option of StyleList" [value]="option?.styleId">
                                  {{option?.styleName}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div class="exp-panel">
                    <mat-accordion>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'questions.typeOfQuestions.TrueOrFalse.accordian.title' | translate}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <form [formGroup]="userForm">
                          <div class="container-fluid  body-section-2">
                            <div class="row" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                              <div class="col-md-2">
                                <div class="scoring-check">
                                  <mat-checkbox name="autoscoring" formControlName="autoscore" [checked]="autoscoring"
                                    [ngClass]="{ 'is-invalid': submitted && f.autoscore.errors }" [disabled]="true">
                                    <b>{{'questions.typeOfQuestions.TrueOrFalse.accordian.checkbox' | translate}}</b>
                                  </mat-checkbox>
                                  <div *ngIf="submitted && f.autoscore.errors" class="invalid-feedback">
                                    <div *ngIf="f.autoscore.errors.required">Field is required</div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="scoring-check">
                                  <div *ngIf="submitted && f.shuffle.errors" class="invalid-feedback">
                                    <div *ngIf="f.shuffle.errors.required">Field is required</div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-2" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                                <div class="form-label">
                                  <label>{{'questions.typeOfQuestions.TrueOrFalse.accordian.selectOptions.option1.label' | translate}}</label>
                                </div>
                              </div>
                              <div class="col-md-3" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">
                                <mat-form-field class="scoring-type" appearance="fill" [hideRequiredMarker]="hideRequiredControl.value"
                                  [floatLabel]="floatLabelControl.value">
                                  <mat-select formControlName="scoringTypeMatch" [(value)]="getscoringtype" [disabled]="true">
                                    <mat-option [value]="option.id == 1 ? 'true' : 'false'" *ngFor="let option of QuestionScoringType">{{option.title}}</mat-option>
                                  </mat-select>
                                  <div *ngIf="submitted && f.scoringTypeMatch.errors" class="invalid-feedback">
                                    <div *ngIf="f.scoringTypeMatch.errors.required">Field is required</div>
                                  </div>
                                </mat-form-field>
                              </div>
                              <div class="col-md-2 answers-label">
                                <div class="form-label">
                                  <label>{{'questions.typeOfQuestions.TrueOrFalse.accordian.selectOptions.option2.label' | translate}}</label>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <mat-form-field class="scoring-type" appearance="fill">
                                  <mat-select formControlName="questionDisplay" [(value)]="getQuestionDisplay">
                                    <mat-option [value]="option.title" *ngFor="let option of QuestionOrientation">{{option.title}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="row" *ngIf="scoringTypeId == ScoringTypeEnum.OnQuestion">

                              <!-- <div class="col-md-2">
                                <div class="form-label score-labels">
                                  <label>{{'questions.typeOfQuestions.TrueOrFalse.accordian.selectOptions.option3' | translate}}</label>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <input [attr.disabled]="true" type="number" min="0" max="9999" onkeypress="if(this.value.length == 4 ) return false;"
                                  class="form-control  penalty-points" [ngClass]="{ 'is-invalid': submitted && f.penaltyPoint.errors }">
                                <div *ngIf="submitted && f.penaltyPoint.errors" class="invalid-feedback">
                                  <div *ngIf="f.penaltyPoint.errors.required">Field is required</div>
                                </div>
                              </div> -->
                              <div class="col-md-2">
                                <div class="form-label score-labels">
                                  <label required>{{'questions.typeOfQuestions.TrueOrFalse.accordian.selectOptions.option4.label' | translate}}</label>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <input type="number" class="form-control penalty-points" min="0" max="9999.99" step=".01"
                                (change)="addScore(o)" (input)="validateInput($event, 0, 'minimumScore')" formControlName="minimumScoreIfAttempt"
                                [ngClass]="{ 'is-invalid': submitted && f.minimumScoreIfAttempt.errors }" (keypress)="omit_special_char($event)">

                                <!-- <input type="number" min="0" max="9999" onkeypress="if(this.value.length == 4 ) return false;"
                                  formControlName="minimumScoreIfAttempt" class="form-control  penalty-points"
                                  [ngClass]="{ 'is-invalid': submitted && f.minimumScoreIfAttempt.errors }"
                                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"> -->
                                <div *ngIf="f.minimumScoreIfAttempt.errors" class="alert alert-danger zero">
                                  <div *ngIf="f.minimumScoreIfAttempt.errors.required">{{'questions.typeOfQuestions.TrueOrFalse.accordian.selectOptions.option4.errorMsg1' | translate}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="display">
    <app-choose-question-type></app-choose-question-type>
  </div>
</div>

<div *ngIf="listDisplay">
  <app-question-list></app-question-list>
</div>
